import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	clients: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
			//order: { name: 'DESC' },
			//filters: {},
		},
	},
	client: { error: null, loading: false, data: null },
	dependents: { error: null, loading: false, data: null },
	editedClient: { error: null, loading: false, data: null },
	removedClient: { error: null, loading: false, data: null },
	createdClient: { error: null, loading: false, data: null },
	genders: { error: null, loading: false, data: null },
	clientStatuses: { error: null, loading: false, data: null },
	maritalStatuses: { error: null, loading: false, data: null },
	plans: { error: null, loading: false, data: null },
	deliveryPreferences: { error: null, loading: false, data: null },
	downloadCsv: { error: null, loading: false },
};

const { actions, reducer } = createSlice({
	name: 'clients',
	initialState,
	reducers: {
		getDependents: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.dependents = {
				...state.dependents,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getDependentsFailure: (state, { payload }) => {
			state.dependents = {
				...state.dependents,
				error: payload,
				loading: false,
			};
		},
		getDependentsSuccess: (state, { payload }) => {
			state.dependents = {
				...state.dependents,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getClients: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.clients = {
				...state.clients,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getClientsFailure: (state, { payload }) => {
			state.clients = {
				...state.clients,
				error: payload,
				loading: false,
			};
		},
		getClientsSuccess: (state, { payload }) => {
			state.clients = {
				...state.clients,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getClientById: (state, { payload }) => {
			state.client = {
				...state.client,
				error: null,
				loading: true,
			};
		},
		getClientByIdFailure: (state, { payload }) => {
			state.client = {
				...state.client,
				error: payload,
				loading: false,
			};
		},
		getClientByIdSuccess: (state, { payload }) => {
			state.client = {
				...state.client,
				data: payload,
				error: null,
				loading: false,
			};
		},
		updateClient: (state, { payload }) => {
			state.editedClient = {
				...state.editedClient,
				error: null,
				loading: true,
			};
		},
		updateClientFailure: (state, { payload }) => {
			state.editedClient = {
				...state.editedClient,
				error: payload,
				loading: false,
			};
		},
		updateClientSuccess: (state, { payload }) => {
			state.editedClient = {
				...state.editedClient,
				data: payload,
				error: null,
				loading: false,
			};
		},
		removeClient: (state, { payload }) => {
			state.removedClient = {
				...state.removedClient,
				error: null,
				loading: true,
			};
		},
		removeClientFailure: (state, { payload }) => {
			state.removedClient = {
				...state.removedClient,
				error: payload,
				loading: false,
			};
		},
		removeClientSuccess: (state, { payload }) => {
			state.removedClient = {
				...state.removedClient,
				data: payload,
				error: null,
				loading: false,
			};
		},
		createClient: (state, { payload }) => {
			state.createdClient = {
				...state.createdClient,
				error: null,
				loading: true,
			};
		},
		createClientFailure: (state, { payload }) => {
			state.createdClient = {
				...state.createdClient,
				error: payload,
				loading: false,
			};
		},
		createClientSuccess: (state, { payload }) => {
			state.createdClient = {
				...state.createdClient,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getGenders: (state) => {
			state.genders = {
				...state.genders,
				error: null,
				loading: true,
			};
		},
		getGendersFailure: (state, { payload }) => {
			state.genders = {
				...state.genders,
				error: payload,
				loading: false,
			};
		},
		getGendersSuccess: (state, { payload }) => {
			state.genders = {
				...state.genders,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getClientStatuses: (state) => {
			state.clientStatuses = {
				...state.clientStatuses,
				error: null,
				loading: true,
			};
		},
		getClientStatusesFailure: (state, { payload }) => {
			state.clientStatuses = {
				...state.clientStatuses,
				error: payload,
				loading: false,
			};
		},
		getClientStatusesSuccess: (state, { payload }) => {
			state.clientStatuses = {
				...state.clientStatuses,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getMaritalStatuses: (state) => {
			state.maritalStatuses = {
				...state.maritalStatuses,
				error: null,
				loading: true,
			};
		},
		getMaritalStatusesFailure: (state, { payload }) => {
			state.maritalStatuses = {
				...state.maritalStatuses,
				error: payload,
				loading: false,
			};
		},
		getMaritalStatusesSuccess: (state, { payload }) => {
			state.maritalStatuses = {
				...state.maritalStatuses,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getPlans: (state) => {
			state.plans = {
				...state.plans,
				error: null,
				loading: true,
			};
		},
		getPlansFailure: (state, { payload }) => {
			state.plans = {
				...state.plans,
				error: payload,
				loading: false,
			};
		},
		getPlansSuccess: (state, { payload }) => {
			state.plans = {
				...state.plans,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getDeliveryPreferences: (state) => {
			state.deliveryPreferences = {
				...state.deliveryPreferences,
				error: null,
				loading: true,
			};
		},
		getDeliveryPreferencesFailure: (state, { payload }) => {
			state.deliveryPreferences = {
				...state.deliveryPreferences,
				error: payload,
				loading: false,
			};
		},
		getDeliveryPreferencesSuccess: (state, { payload }) => {
			state.deliveryPreferences = {
				...state.deliveryPreferences,
				data: payload,
				error: null,
				loading: false,
			};
		},
		downloadCsv: (state, { payload }) => {
			state.downloadCsv = {
				...state.downloadCsv,
				error: null,
				loading: true,
			};
		},
		downloadCsvFailure: (state, { payload }) => {
			state.downloadCsv = {
				...state.downloadCsv,
				error: payload,
				loading: false,
			};
		},
		downloadCsvSuccess: (state, { payload }) => {
			state.downloadCsv = {
				...state.downloadCsv,
				error: null,
				loading: false,
			};
		},
	},
});

export const {
	getClients,
	getClientsSuccess,
	getClientsFailure,
	getDependents,
	getDependentsFailure,
	getDependentsSuccess,
	getClientById,
	getClientByIdSuccess,
	getClientByIdFailure,
	updateClient,
	updateClientSuccess,
	updateClientFailure,
	removeClient,
	removeClientSuccess,
	removeClientFailure,
	createClient,
	createClientSuccess,
	createClientFailure,
	getGenders,
	getGendersSuccess,
	getGendersFailure,
	getClientStatuses,
	getClientStatusesSuccess,
	getClientStatusesFailure,
	getMaritalStatuses,
	getMaritalStatusesSuccess,
	getMaritalStatusesFailure,
	getPlans,
	getPlansSuccess,
	getPlansFailure,
	getDeliveryPreferences,
	getDeliveryPreferencesSuccess,
	getDeliveryPreferencesFailure,
	downloadCsv,
	downloadCsvFailure,
	downloadCsvSuccess,
} = actions;

export { default as clientsSaga } from './sagas';

export default reducer;
